<template>
  <div class="New_Analyst">
    <div class="dateNewAnalyst" v-html="postDate"></div>
    <h2 class="tt">
      <a :href="post.postUrl" v-html="post.title"></a>
    </h2>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("es-co");

export default {
  props: {
    post: Object,
    groupName: String,
  },
  computed: {
    postDate: function () {
      return moment(this.post.create).format("dddd, D [DE] MMMM [DE] YYYY");
    },
  },
};
</script>
